import { render } from "./PublicObjectViewer.vue?vue&type=template&id=bc616196&scoped=true"
import script from "./PublicObjectViewer.vue?vue&type=script&lang=js"
export * from "./PublicObjectViewer.vue?vue&type=script&lang=js"

import "./PublicObjectViewer.vue?vue&type=style&index=0&id=bc616196&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc616196"]])

export default __exports__